import { ajax } from "rxjs/ajax";

export const request = (
  url,
  options = { headers: { "Content-Type": "application/json" } }
) => {
  const congitoKey = window.localStorage.cognitoKey;
  const user = window.localStorage[`${congitoKey}.LastAuthUser`];
  const token = window.localStorage[`${congitoKey}.${user}.accessToken`];
  if (token) {
    options.headers = {
      ...options.headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  return ajax({
    url,
    ...options,
    headers: { ...(options.headers || {}) },
  });
};
